import { toPng } from "html-to-image"
import { Rect } from "../../../common/src/geometry"

const TARGET_PX_PER_EM = 20 // roughly "zoom 2" legibility
const MAX_PIXELS = 16_000_000

// Rasterize a region (in board em units) of the board element and download it as PNG.
// ponytail: html-to-image does the DOM cloning/style inlining; we only crop by translating the clone.
export async function exportBoardPng(boardEl: HTMLElement, rectEm: Rect, pxPerEm: number, filename: string) {
    const x = rectEm.x * pxPerEm
    const y = rectEm.y * pxPerEm
    const width = Math.ceil(rectEm.width * pxPerEm)
    const height = Math.ceil(rectEm.height * pxPerEm)
    let pixelRatio = TARGET_PX_PER_EM / pxPerEm
    pixelRatio = Math.min(pixelRatio, Math.sqrt(MAX_PIXELS / (width * height)))

    const dataUrl = await toPng(boardEl, {
        width,
        height,
        pixelRatio,
        style: { transform: `translate(${-x}px, ${-y}px)`, transformOrigin: "top left" },
        filter: (node) =>
            !(
                node instanceof HTMLElement &&
                ["cursor", "reaction", "board-search", "rectangular-drag-selection"].some((c) =>
                    node.classList.contains(c),
                )
            ),
    })
    const a = document.createElement("a")
    a.href = dataUrl
    a.download = filename
    a.click()
}
